// Type Imports
import type { AuthActionResponse } from '@refinedev/core'

export const LOGIN_FAILED_MESSAGE = 'Нэвтрэх үед алдаа гарлаа'

/** Амжилттай нэвтэрсний дараа шилжилт дуусаагүй бол «Нэвтрэх» товчийг дахин идэвхжүүлэх хугацаа. */
export const REDIRECT_GRACE_MS = 15_000

/**
 * Нэвтрэлтийн амжилтгүй хариуны мессеж; амжилттай бол `null`.
 *
 * ! `authProvider.login` алдааг ШИДЭХГҮЙ, `{ success: false }` БУЦААДАГ (Refine-ийн гэрээ) — тиймээс
 * ! `useLogin().mutate`-ийн `onError` ХЭЗЭЭ Ч дуудагдахгүй, хариу `onSuccess`-д ирнэ. Урьд нь маягтууд
 * ! зөвхөн `onError`-д алдаа харуулдаг байсан тул буруу нууц үг, түгжээ, сүлжээний алдаа ЧИМЭЭГҮЙ өнгөрч
 * ! (суралцагчийн хуудсанд toast ч байхгүй) — хэрэглэгч «юу ч болсонгүй» гээд хуудсаа дахин ачаалдаг байв.
 */
export const loginFailureMessage = (result: AuthActionResponse): string | null =>
  result.success ? null : result.error?.message || LOGIN_FAILED_MESSAGE
